import { useRef } from "react";
import { useSelector } from "react-redux";
import { loadingServiceSlice } from "../StateManagement/loadingServiceSlice";

export const useLoadState = (name) => {
  const nameRef = useRef(name || "");

  const loading = useSelector((state) => {
    if (nameRef.current) {
      return state?.[loadingServiceSlice.name]?.profiles[nameRef.current];
    } else {
      return state?.[loadingServiceSlice.name]?.loading;
    }
  });

  return loading;
};
